import { render, staticRenderFns } from "./AdminNav.vue?vue&type=template&id=452ac4d4&scoped=true&"
import script from "./AdminNav.vue?vue&type=script&lang=js&"
export * from "./AdminNav.vue?vue&type=script&lang=js&"
import style0 from "./AdminNav.vue?vue&type=style&index=0&id=452ac4d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452ac4d4",
  null
  
)

export default component.exports